// @ts-nocheck
import $ from 'jquery';
import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import batterynormal from '../images/battery-normal.svg';
import PlugSolid from '../images/PlugSolid.svg';
import UnPlug from '../images/Unplug.svg';

const dryFormatter = {
    dryBatteryStatusSorting: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryStatus != null && params.data.BatteryStatus != undefined) {
                switch (params.data.BatteryStatus.toString().toUpperCase().trim()) {
                    case "C":
                        return "1";
                    case "L":
                        return "2";
                    case "N":
                        return "3";
                }
            }
            return "-1";
        }
        return "-1";
    },
    dryBatteryStatusFormatterFilter: (params) => {

        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryStatus != null && params.data.BatteryStatus != undefined) {
                //var element = document.createElement("span");
                //element.className = "pwr_grid_icon";
                //var imageElement = document.createElement("img");

                switch (params.data.BatteryStatus.toString().toUpperCase().trim()) {
                    case "C":
                        title = "Critical";
                        break;
                    case "L":
                        title = "Low";
                        break;
                    case "N":
                        title = "Normal";
                        break;
                }
                //element.appendChild(imageElement);
                //return element;
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";
        return title;
    },

    dryBatteryStatusFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryStatus != null && params.data.BatteryStatus != undefined) {
                var element = document.createElement("span");
                element.className = "pwr_grid_icon";
                var imageElement = document.createElement("img");

                switch (params.data.BatteryStatus.toString().toUpperCase().trim()) {
                    case "C":
                        imageElement.src = batterycritical;
                        break;
                    case "L":
                        imageElement.src = batterylow;
                        break;
                    case "N":
                        imageElement.src = batterynormal;
                        break;
                }
                element.appendChild(imageElement);
                return element;
            }
        }
        return '-NA-';
    },
    dryPWRSorting: (params) => {
        //return "-NA-";
        if (params.data != null && params.data != undefined) {
            if (params.data.DryPWR != null && params.data.DryPWR != undefined) {
                switch (params.data.DryPWR.toString().toUpperCase().trim()) {
                    case "A":
                        return "1";
                    case "B":
                        return "2";
                    //case "N":
                    //    return "3";
                }
            }
            return "3";
        }
        return "3";
    },
    dryPwrStateFormatterFilter: (params) => {
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.DryPWR != null && params.data.DryPWR != undefined) {

                switch (params.data.DryPWR.toString().toUpperCase().trim()) {
                    case "1":
                    case "A":
                        title = "Powered";
                        break;
                    case "2":
                    case "B":
                        title = "On Battery";
                        break;
                    case "3":
                        title = "-NA-";
                        break;
                }
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";
        return title;
    },
    pwrStateFormatterdry: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.DryPWR != null && params.data.DryPWR != undefined) {
                var element = document.createElement("span");
                element.className = "pwr_grid_icon";
                var imageElement = document.createElement("img");

                switch (params.data.DryPWR.toString().toUpperCase().trim()) {
                    case "A":
                        element.className = "PlugSolid";
                        element.title = "Powered"
                        imageElement.src = PlugSolid;
                        break;
                    case "B":
                        element.className = "PlugSolid";
                        element.title = "On Battery"
                        imageElement.src = UnPlug;
                        break;
                }
                element.appendChild(imageElement);
                return element;
            }
        }
        //return '-NA-';
        return "-NA-";
    },

    doorFormatterFilter: (params) => {
        
        //RCNG-2227,2228
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.Door1Open != null) {
                    
                    //if (params.data.Door1Open.toString().toUpperCase().trim() == "TRUE")
                    //    return "Open";
                    //else
                    //    return "Closed";
                    switch (params.data.Door1Open.toString().toUpperCase().trim()) {
                        case "OPN":
                            return "Open";
                        case "CLS":
                            return "Closed";
                        case "DIS":
                            return "Sensor Error"
                        case "UNP":
                            return "No Sensor";
                        case "UNK":
                            return "-NA-";
                    }
                }
                else
                    return "-NA-";
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },
    DoorFormatterSorting: (params) => {
        
        //RCNG-2227,2228
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.Door1Open != null) {
                    //if (params.data.Door1Open.toString().toUpperCase().trim() == "TRUE")
                    //    return "1";
                    //else
                    //    return "2";
                    switch (params.data.Door1Open.toString().toUpperCase().trim()) {
                        case "OPN":
                            return "1";
                        case "CLS":
                            return "2";
                        case "DIS":
                            return "3"
                        case "UNP":
                            return "4";
                        case "UNK":
                            return "5";
                    }
                }
                else
                    return "5";
            }
            else
                return "4";
        }
        else
            return '5';
    },

    doorFormatter: (params) => {
        
        //RCNG-2227,2228
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.Door1Open != null) {
                    //if (params.data.Door1Open.toString().toUpperCase().trim() == "TRUE")
                    //    return "Open";
                    //else
                    //    return "Closed";
                    switch (params.data.Door1Open.toString().toUpperCase().trim()) {
                        case "OPN":
                            return "Open";
                        case "CLS":
                            return "Closed";
                        case "DIS":
                            return "Sensor Error";
                        case "UNP":
                            return "No Sensor";
                        case "UNK":
                            return "-NA-";
                    }
                }
                else
                    return "-NA-";
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },
    
    doorQuickFilterFormatter: (param) => {
        
        if (param != null && param != undefined) {
            if (param.value == 1)
                return "Open";
            else if (param.value == 2)
                return "Closed";
            else if (param.value == 3)
                return "Sensor Error"
            else if (param.value == 4)
                return "No Sensor"
            else if (param.value == 5)
                return "*No Door"
            else
                return "-NA-";
        }
    },

    SpeedConverter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params.value != null && params.value != '-NA-') {
            if (speedUnitCd.toLowerCase() == "kmh") {
                var param = params.value;
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempVal = parseFloat(params.value);
                var param1 = (tempVal / 1.609344);
                return parseFloat(param1.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    },

    SpeedConverterFilter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params.data.DrySpeed != null) {
            if (speedUnitCd.toLowerCase() == "kmh") {
                var param = params.data.DrySpeed;
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempVal = parseFloat(params.data.DrySpeed);
                var param1 = (tempVal / 1.609344);
                return parseFloat(param1.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    },
    TemperatureValueFormatter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else {
                    var tempVal = parseFloat(params.value);
                    if ((params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "ST9100")) {
                        //if (tempVal == 0)
                        return '-NA-';
                    }
                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        /* return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)) :
                            param.toFixed(1);*/
                        return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                            param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
                    }
                    else
                        /*    return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)):
                            param.toFixed(1);*/
                        return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                            tempVal.toFixed(parseInt(tempRoundingValue)) : tempVal.toFixed(1);
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    floatTypeSortingFieldName: (param, FieldName) => {
        if (param != null && param != undefined) {
            if (param.data != null && param.data != undefined) {

                switch (FieldName) {
                    case 'GeofenceDefinitionRevision':
                        return param.data.GeofenceDefinitionRevision != null && param.data.GeofenceDefinitionRevision != "" && param.data.GeofenceDefinitionRevision != "null" ? param.data.GeofenceDefinitionRevision : '-NA-';
                    case 'DryGPSHDOP':
                        return param.data.DryGPSHDOP != null && param.data.DryGPSHDOP != "" && param.data.DryGPSHDOP != "null" ? param.data.DryGPSHDOP : '-NA-';
                    case 'DryGPSSatelliteCount':
                        return param.data.DryGPSSatelliteCount != null && param.data.DryGPSSatelliteCount != "" && param.data.DryGPSSatelliteCount != "null" ? param.data.DryGPSSatelliteCount : '-NA-';
                    case 'DrySpeed':
                        return param.data.DrySpeed != null && param.data.DrySpeed != "null" ? param.data.DrySpeed : '-NA-';//RCNG-1185
                    case 'Miles':
                        return param.data.Miles != null && param.data.Miles != "" && param.data.Miles != "null" ? param.data.Miles : '-NA-';
                    default:
                        return '-NA-';
                }
            }
            else
                return '-NA-';

        }
        else
            return '-NA-';
    },

    DryBattVoltageSortingFieldName: (params, FieldName) => {

        if (params != null && params != undefined) {

            if (params.data != null && params.data != undefined) {
                var tempRoundingValue = "1";
                return (params.data.BattVoltage != null) ? parseFloat(params.data.BattVoltage.toFixed(parseInt(tempRoundingValue))) : -999;
            }
            else
                return -999;
        }
        else
            return -999;
    },

    CommentExistsforDrySorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.CommentExistsDC != null && params.data.CommentExistsDC != undefined) {
                if (params.data.CommentExistsDC == 0) {
                    return 0;
                }
                else
                    return '-NA-';
            }
        }

    },
    //RCNG-2227,2228
    dryDoorBattPctSorting: (params) => {
        
        if (params.data != null && params.data != undefined) {
            if (params.data.Door1BattPct != null && params.data.Door1BattPct != undefined) {
                var battPct = (Math.round(params.data.Door1BattPct / 10.0)) * 10;
                return battPct.toString();
            }
            return "-1";
        }
        return "-1";
    },
    dryDoorBattPctFormatterFilter: (params) => {
        
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.Door1BattPct != null && params.data.Door1BattPct != undefined) {
                var battPct = (Math.round(params.data.Door1BattPct / 10.0)) * 10;
                title = battPct.toString();
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";
        return title;
    },
    dryBatteryPctSorting: (params) => {
        
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryPct != null && params.data.BatteryPct != undefined && params.data.BatteryPct >=0) {
                var battPct = (Math.round(params.data.BatteryPct / 10.0)) * 10;
                return battPct.toString();
            }
            return "-1";
        }
        return "-1";
    },
	
	dryBatteryPctFormatterFilter: (params) => {        
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryPct != null && params.data.BatteryPct != undefined) {
                var battPct = (Math.round(params.data.BatteryPct / 10.0)) * 10;
                title = battPct.toString();
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";
        return title;
    },
    BatteryModeFormatterFilter:(params) => {
        if(params.data.BatteryMode != null && params.data.BatteryMode != "" && params.data.BatteryMode != "null")
        {
            var BatteryMode = params.data.BatteryMode;
            if(BatteryMode == "N")
                return "Normal";
            else if(BatteryMode == "B")
                return "Backup";
            else if(BatteryMode == "T")
                return "Tertiary";
            else if(BatteryMode == "R")
                return "Reserve";
            else return "-NA-";
        }
        else return "-NA-";
    }
}

export default dryFormatter;